import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import {AccentColorOptions} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps';
import {
    GridContainer,
    CenteredGrid,
    LineTextBlock,
    VerticalSpacer,
    ImageCard,
    ImageCardProps
} from '..';

const Styled = styled.div`
    .description .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }

    .cardItemInner {
        margin-right: 25px;
        margin-bottom: 25px;
    }

    & .ue-centered-grid {
        width: initial;
    }

    .imagecardlist-wrapper {
        align-items: flex-start;
    }
`;

export interface ImageCardListProps {
    accentColor?: AccentColorOptions;
    cards?: ImageCardProps[];
    description?: string;
    heading?: string;
    itemLabel?: string;
    osLabel?: string;
    desktopSearchLabel?: string;
}

export const ImageCardList = (props: ImageCardListProps): JSX.Element => {
    const {heading, accentColor, cards = []} = props;

    const noPadding = {padding: 0};
    const noMargin = {margin: 0};
    let ImageCardProps: ImageCardProps;

    return (
        <Styled>
            <GridContainer>
                {heading && (
                    <Grid item xs={12} sm={true}>
                        <LineTextBlock headline={heading} accentColor={accentColor} disableAnim />
                        <VerticalSpacer variant="custom" spacing={3} downSmSpacing={2} />
                    </Grid>
                )}

                <CenteredGrid className="imagecardlist-wrapper" style={noMargin}>
                    {cards.length ? (
                        <>
                            {cards.map((cardProps, index) => {
                                return (
                                    <Grid
                                        className="cardItemOuter"
                                        item
                                        xs={12}
                                        md={3}
                                        key={`card-grid-item-${index}`}
                                        style={noPadding}>
                                        <AnimateOnViewWrap
                                            translateY={30 + (index % 3) * 10}
                                            delay={(index % 3) * 0.3}>
                                            <div className="cardItemInner">
                                                <ImageCard
                                                    {...cardProps}
                                                    imageHoverEffect="scaleIn"
                                                    accentColor={accentColor}
                                                    {...ImageCardProps}
                                                />
                                            </div>
                                        </AnimateOnViewWrap>
                                    </Grid>
                                );
                            })}
                        </>
                    ) : (
                        ''
                    )}
                </CenteredGrid>
            </GridContainer>
        </Styled>
    );
};
